import store from '../store'
import Login from '@/components/login'
import Logout from '@/components/logout'

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (to.path === '/') {
      const username = localStorage.getItem('username')
      const profileSkey = localStorage.getItem('profile_skey')
      if (profileSkey === '14') {
        next('/WpLabResultReportAI')
      } else if (profileSkey === '1' || username === 'admin') {
        next()
      } else {
        next('/WpLabRequest')
      }
      return
    }
    next()
    return
  }
  next('/login')
}

const ifAdmin = (to, from, next) => {
  const username = localStorage.getItem('username')
  const profileSkey = localStorage.getItem('profile_skey')
  if (profileSkey === '1' || username === 'admin') {
    next()
    return
  }
  next('/')
}

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    // beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/',
    component: () => import('@/views/dashboard/Index'),
    beforeEnter: ifAuthenticated,
    children: [
      // Dashboard
      /* First component */
      /* {
        name: 'Dashboard',
        path: '',
        component: () => import('@/views/dashboard/Dashboard'),
      }, */
      {
        path: '',
        name: 'monitor',
        component: () => import('@/components/monitor'),
      },
      // Pages
      // {
      //   path: '/login',
      //   name: 'Login',
      //   component: Login,
      //   // beforeEnter: ifNotAuthenticated,
      // },
      // {
      //   path: '/logout',
      //   name: 'Logout',
      //   component: Logout,
      // },
      {
        path: '/Account',
        name: 'Account',
        component: () => import('components/account'),
      },
      {
        path: '/NavWindow',
        name: 'NavWindow',
        component: () => import('@/components/navigation/NavWindow'),
      },
      {
        path: '/NavNode',
        name: 'NavNode',
        component: () => import('@/components/navigation/NavNode'),
      },
      {
        path: '/NavRoute',
        name: 'NavRoute',
        component: () => import('@/components/navigation/NavRoute'),
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/components/user'),
        beforeEnter: ifAdmin,
      },
      {
        path: '/userProfile',
        name: 'userProfile',
        component: () => import('@/components/userProfile'),
      },
      {
        path: '/userGroup',
        name: 'userGroup',
        component: () => import('@/components/userGroup'),
      },
      {
        path: '/monitorDetail',
        name: 'monitorDetail',
        component: () => import('@/components/monitorDetail'),
      },
      {
        path: '/WpLabRequest',
        name: 'WpLabRequest',
        component: () => import('@/components/WpLabRequest'),
      },
      {
        path: '/apiClientManagement',
        name: 'apiClientManagement',
        component: () => import('@/components/apiClientManagement'),
      },
      {
        path: '/protocolManagement',
        name: 'protocolManagement',
        component: () => import('@/components/protocolManagement'),
      },
      {
        path: '/driverManagement',
        name: 'driverManagement',
        component: () => import('@/components/driverManagement'),
      },
      {
        path: '/Facility',
        name: 'Facility',
        component: () => import('@/components/Facility'),
      },
      {
        path: '/Stockroom',
        name: 'Stockroom',
        component: () => import('@/components/Stockroom'),
      },
      {
        path: '/Location',
        name: 'Location',
        component: () => import('@/components/Location'),
      },
      {
        path: '/ItemMaster',
        name: 'ItemMaster',
        component: () => import('@/components/ItemMaster'),
      },
      {
        path: '/ResultItem',
        name: 'ResultItem',
        component: () => import('@/components/ResultItem'),
      },
      {
        path: '/TestItem',
        name: 'TestItem',
        component: () => import('@/components/TestItem'),
      },
      {
        path: '/OrderItem',
        name: 'OrderItem',
        component: () => import('@/components/OrderItem'),
      },
      {
        path: '/IQCLevel',
        name: 'IQCLevel',
        component: () => import('@/components/IQCLevel'),
      },
      {
        path: '/LISUOM',
        name: 'LISUOM',
        component: () => import('@/components/LISUOM'),
      },
      {
        path: '/LISSpecimenType',
        name: 'LISSpecimenType',
        component: () => import('@/components/LISSpecimenType'),
      },
      {
        path: '/LISSourceSpecimen',
        name: 'LISSourceSpecimen',
        component: () => import('@/components/LISSourceSpecimen'),
      },
      {
        path: '/LISRejectReason',
        name: 'LISRejectReason',
        component: () => import('@/components/LISRejectReason'),
      },
      {
        path: '/LISResultType',
        name: 'LISResultType',
        component: () => import('@/components/LISResultType'),
      },
      {
        path: '/LISLogicalLocation',
        name: 'LISLogicalLocation',
        component: () => import('@/components/LISLogicalLocation'),
      },
      {
        path: '/LISSpecimenSticker',
        name: 'LISSpecimenSticker',
        component: () => import('@/components/LISSpecimenSticker'),
      },
      {
        path: '/LISMethod',
        name: 'LISMethod',
        component: () => import('@/components/LISMethod'),
      },
      {
        path: '/LISCategory',
        name: 'LISCategory',
        component: () => import('@/components/LISCategory'),
      },
      {
        path: '/LISOutLabProcessing',
        name: 'LISOutLabProcessing',
        component: () => import('@/components/LISOutLabProcessing'),
      },
      {
        path: '/LISOutLabPendingList',
        name: 'LISOutLabPendingList',
        component: () => import('@/components/LISOutLabPendingList'),
      },
      {
        path: '/WpCustomer',
        name: 'WpCustomer',
        component: () => import('@/components/WpCustomer'),
      },
      {
        path: '/GlobalParms',
        name: 'GlobalParms',
        component: () => import('@/components/GlobalParms'),
      },
      {
        path: '/WpOrderItem',
        name: 'WpOrderItem',
        component: () => import('@/components/WpOrderItem'),
      },
      {
        path: '/WpTestItem',
        name: 'WpTestItem',
        component: () => import('@/components/WpTestItem'),
      },
      {
        path: '/WpResultItem',
        name: 'WpResultItem',
        component: () => import('@/components/WpResultItem'),
      },
      {
        path: '/ServiceChannel',
        name: 'ServiceChannel',
        component: () => import('@/components/serviceChannelManagement'),
      },
      {
        path: '/WpLabResultReportAI',
        name: 'WpLabResultReportAI',
        component: () => import('@/components/WpLabResultReportAI'),
      },
      {
        path: '/LISOutLabProcessing',
        name: 'LISOutLabProcessing',
        component: () => import('@/components/LISOutLabProcessing'),
      },
      {
        path: '/LISOutLabPendingList',
        name: 'LISOutLabPendingList',
        component: () => import('@/components/LISOutLabPendingList'),
      },
      {
        path: '/LISIQCLotMaint',
        name: 'LISIQCLotMaint',
        component: () => import('@/components/LISIQCLotMaint'),
      },
      {
        path: '/LISIQCResult',
        name: 'LISIQCResult',
        component: () => import('@/components/LISIQCResult'),
      },
      {
        path: '/WpLabReceive',
        name: 'WpLabReceive',
        component: () => import('@/components/WpLabReceive'),
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/components/about'),
      },
      /* {
        path: '/LISIQCLotClone',
        name: 'LISIQCLotClone',
        component: () => import('@/components/LISIQCLotClone'),
      },
      {
        path: '/LISIQCResultAutoCalc',
        name: 'LISIQCResultAutoCalc',
        component: () => import('@/components/LISIQCResultAutoCalc'),
      }, */
    ],
  },
]
